import Marquee from "react-fast-marquee";
import { useLang, T } from "../../lib/i18n";

export const MarqueeStrip = ({ dark = false }) => {
  const { lang } = useLang();
  const items = T[lang].marquee;
  return (
    <div data-testid="marquee-strip" className={`py-8 md:py-12 border-y ${dark ? "border-white/10 bg-[#0B2530] text-white/50" : "border-slate-900/10 bg-transparent text-slate-400"}`}>
      <Marquee speed={30} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="mx-8 md:mx-14 flex items-center gap-8 md:gap-14 font-serif italic text-2xl md:text-4xl tracking-tight whitespace-nowrap">
            {t}
            <span className="text-[#00B4D8] not-italic text-lg">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
